import styled from 'styled-components';

export const HeaderText = styled.h1<{
  weight?: string;
  size?: string;
  color?: string;
  margin?: string;
}>`
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.headingH3.fontFamily};
  font-size: ${(props) => {
    switch (props.size) {
      case 'small':
        return '15px';
      case 'regular':
        return '21px';
      case 'medium':
        return '24px';
      case 'large':
        return '28px';
      default:
        return '21px';
    }
  }};

  font-weight: ${(props) => {
    switch (props.weight) {
      case 'light':
        return '100';
      case 'regular':
        return '400';
      case 'medium':
        return '500';
      default:
        return '400';
    }
  }};

  color: ${(props) =>
    props.color ? props.color : props.theme.atlas.semantic.color.type.default};
  word-break: break-word;
  margin: ${(props) => props.margin ?? '0'};
`;
